import React from "react";
import { JobArrangerLayout } from "../JobArrangerLayout";
import { JobArrangerEntities } from "../JobArrangerEntities";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { JobArrangerProps } from "../JobArrangerProps";

interface ReasonViewPageProps extends NSARouterMakerProps, JobArrangerProps { }

class ReasonViewPage extends React.Component<ReasonViewPageProps>
{
	override render()
	{
		return (
			<JobArrangerLayout
				{...this.props}
				pages={{
					entity: JobArrangerEntities.reason(this.props),
					view: {}
				}}
			>
				<></>
			</JobArrangerLayout>
		);
	}
}

export default ReasonViewPage;